export enum FileFormatEnum {
  CSV = 'CSV',
  PDF = 'PDF'
}